import {createCheckoutProfileHandlers} from './createCheckoutProfileHandlers';
import {createCheckoutProfileRuleHandlers} from './createCheckoutProfileRuleHandlers';
import {
  createCheckoutProfilesMockState,
  type CheckoutProfilesMockOptions,
  type CheckoutProfilesMockState,
} from './createCheckoutProfilesMockState';

export function createCheckoutProfilesHandlers(
  options: CheckoutProfilesMockOptions & {state?: CheckoutProfilesMockState} = {}
) {
  const state = options.state ?? createCheckoutProfilesMockState(options);
  return [...createCheckoutProfileHandlers(state), ...createCheckoutProfileRuleHandlers(state)];
}
